/* eslint-disable @typescript-eslint/no-explicit-any */ // TODO: Remove this disable and fix all any types in this file
import { computed, Ref } from "vue";
import { useLoadConfigProductAndAsset } from "@/shared/configurations/product-and-asset/load-product-and-asset-settings";
import { getI18n } from "@/shared/i18n/i18n";
import { AssetNameTypes, assetTextKeys } from "@/abilities/product-and-asset/helpers/product-asset-naming";

export function useAssetNames(subType: AssetNameTypes, params?: Ref<any>) {
    const { loading, configProductAndAsset } = useLoadConfigProductAndAsset();
    const i18n = getI18n();

    return computed(() => {
        if (!loading.value && configProductAndAsset.value) {
            return i18n.global.t(
                "product-and-asset." + assetTextKeys[configProductAndAsset.value.assetName][subType],
                params?.value
            );
        }
        return "";
    });
}
